import { useUserQuery } from '../features/user/useUserQuery';

const SW_ACCOUNT_IDS = [
  10216725,
  10000003, // touch
];

export const isSWUser = (accountId: number | undefined): boolean => {
  return SW_ACCOUNT_IDS.includes(accountId as number);
};

export const useIsSwUser = () => {
  const userQuery = useUserQuery();
  return isSWUser(userQuery.data?.accountId);
};

export const useIsSwUserByEmail = () => {
  const userQuery = useUserQuery();
  return userQuery.data?.email?.endsWith('@similarweb.com');
};
